"use client";

import { Suspense } from "react";
import { AuthProvider } from "@/context/auth/AuthContext";
import { GlobalContextProvider } from "@/context/global/GlobalContext";
import LayoutProvider from "@/providers/layout-provider";
import { ThemeProvider } from "@/providers/theme-provider";
import { SnackbarProvider } from "notistack";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const RootLayoutWrapper = ({ children }) => {
  return (
    <SnackbarProvider
      anchorOrigin={{ horizontal: "right", vertical: "top" }}
      autoHideDuration={5000}
      dense
      preventDuplicate
    >
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Suspense fallback={null}>
            <GlobalContextProvider>
              <ThemeProvider
                attribute="class"
                defaultTheme="light"
                enableSystem
                disableTransitionOnChange
              >
                <LayoutProvider>{children}</LayoutProvider>
              </ThemeProvider>
            </GlobalContextProvider>
          </Suspense>
        </AuthProvider>
      </QueryClientProvider>
    </SnackbarProvider>
  );
};

export default RootLayoutWrapper;
